import { resource, tapEffect } from "@assistant-ui/tap";
import { tapAssistantEmit } from "@assistant-ui/store";
import { tapSubscribable } from "../util-hooks/tapSubscribable.js";
export const ThreadListItemClient = resource(({ runtime, }) => {
    const state = tapSubscribable(runtime);
    const emit = tapAssistantEmit();
    // Bind thread list item events to event manager
    tapEffect(() => {
        const unsubscribers = [];
        // Subscribe to thread list item events
        const threadListItemEvents = [
            "switchedTo",
            "switchedAway",
        ];
        for (const event of threadListItemEvents) {
            const unsubscribe = runtime.unstable_on(event, () => {
                emit(`threadListItem.${event}`, {
                    threadId: runtime.getState().id,
                });
            });
            unsubscribers.push(unsubscribe);
        }
        return () => {
            for (const unsub of unsubscribers)
                unsub();
        };
    }, [runtime, emit]);
    return {
        state,
        methods: {
            getState: () => state,
            switchTo: runtime.switchTo,
            rename: runtime.rename,
            archive: runtime.archive,
            unarchive: runtime.unarchive,
            delete: runtime.delete,
            generateTitle: runtime.generateTitle,
            initialize: runtime.initialize,
            detach: runtime.detach,
            __internal_getRuntime: () => runtime,
        },
    };
});
//# sourceMappingURL=ThreadListItemRuntimeClient.js.map